import {
  UPDATE_QUESTIONNAIRENAIRE,
  UPDATE_QUESTIONNAIRE_SUCCESS,
  UPDATE_QUESTIONNAIRE_FAILURE,
} from 'store/updateQuestionnaire/updateQuestionnaireAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateQuestionnaireReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_QUESTIONNAIRENAIRE:
      return { ...state, loading: true };
    case UPDATE_QUESTIONNAIRE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateQuestionnaireReducer;
